import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const PromtPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;  
`

export const PromptPageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1 1 auto;
`;

export const LeftPromptContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 26px;
`;

export const RightPromptContainer = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 382px);
  overflow-y: auto;
   
  & > div > div > div > div > div {
      background-color: ${(props)=> props.theme.colors.white};
  }  
    
`;


export const InitialPromptWrapper = styled.div`
  position: absolute;
  top: 23%;
  display: flex;
  flex-direction: column;
  gap:16px;
  text-align: center;  
  align-items: center;
  justify-content: center;  
  width: 100%;
    
  & > span:last-child{
      color: ${props => props.theme.colors.davysGrey};
  }  
`;